import Keycloak from "keycloak-js";

const _kc = Keycloak({
    realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
    url: process.env.REACT_APP_KEYCLOAK_URL || '',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || ''
});

const initKeycloak = (onAuthenticatedCallback: any) => {
    _kc.init({
        onLoad: 'check-sso',
        checkLoginIframe: true,
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        enableLogging: false,
        pkceMethod: 'S256',
    })
        .then((authenticated) => {
            if (authenticated && _kc.token) {
                localStorage.setItem('token', _kc.token);
                onAuthenticatedCallback(KeycloakService);
            } else {
              login();
            }
        });
};

const login = _kc.login;

const logout = () => { 
    localStorage.removeItem('token');
    _kc.logout();
};

const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateToken = (minValidity: number) =>
    _kc.updateToken(minValidity)
        .then((refreshed) => {
		 if (refreshed) {
          if (_kc.token)
            localStorage.setItem('token', _kc.token);
          else 
            _kc.login();
		 }})
        .catch(_kc.login);

const getUsername = () => (_kc.tokenParsed as any)?.preferred_username || 'unknown';

const hasRole = (roles: any[]) => roles.some((role) => _kc.hasRealmRole(role));

const getParsedToken = () => _kc.tokenParsed;

const tokenExpired = (minValidity: number) => {
    return _kc.isTokenExpired(minValidity);
}

const KeycloakService = {
    initKeycloak,
    login,
    logout,
    isLoggedIn,
    getToken,
    getParsedToken,
    updateToken,
    getUsername,
    hasRole,
    tokenExpired,
};

export default KeycloakService;